export default {
  tos: `
  Al crear una cuenta aceptas
  los <a href="https://tufirma.digital/terms" target="_blank">Términos y condiciones</a> de servicio
  `
}



// WEBPACK FOOTER //
// ./src/App/i18n/strings/auth/tos/es.js